import { ButtonShadcn } from "@/components/ui/Button";
import useOutreachVariables from "@/hooks/useOutreachVariables";

/**
 * The `{{variable}}` picker. One row of chips; clicking one hands the caller
 * the token to insert at its own caret.
 *
 * One component because the Message Templates and Tone & Style panels each had
 * their own copy, differing only in the colour literals they hard-coded.
 *
 * `variables` defaults to the general outreach set, which is what every
 * outreach-settings caller wants. The compliance composer passes its own list
 * instead: `{{compliance_portal_link}}` resolves to nothing outside a
 * compliance send, so offering it on an ordinary sequence step would be a chip
 * that renders as an em dash (plan Q-VarSplit). A prop, not a fork — the chip
 * itself is identical either way.
 */
const ChipRow = ({ variables, onInsert, className }) => (
  <div className={`flex flex-wrap gap-1 ${className}`}>
    {variables.map((variable) => (
      <ButtonShadcn
        key={variable}
        type="button"
        variant="outline"
        size="xs"
        onClick={() => onInsert(`{{${variable}}}`)}
        title={`Insert {{${variable}}}`}
        className="rounded-lg font-mono text-[10px]"
      >
        {`{{${variable}}}`}
      </ButtonShadcn>
    ))}
  </div>
);

// Only mounted when no list was passed, so the compliance composer never
// fetches the outreach set it would throw away.
// `systemKey` swaps in a system template's own set — see useOutreachVariables.
const OutreachChips = ({ systemKey, ...props }) => <ChipRow variables={useOutreachVariables(systemKey)} {...props} />;

const VariableChips = ({ variables, systemKey, onInsert, className = "" }) =>
  variables ? (
    <ChipRow variables={variables} onInsert={onInsert} className={className} />
  ) : (
    <OutreachChips systemKey={systemKey} onInsert={onInsert} className={className} />
  );

export default VariableChips;
